module.exports = __webpack_public_path__ + "static/media/loader-rolling.5bd400d1.gif";